import { exchangeContactApi } from "@/core/data/api";

export default async (values) => {
  return await exchangeContactApi.createExchangeContact(values);
};
